import get from 'get-value';
import {
    COMMON_INPUT_VALIDATION_REGEX,
    DATE_VALIDATION_REGEX,
    DIGIT_STRING_VALIDATION_REGEX,
    EMAIL_VALIDATION_REGEX,
    FILE_MAX_SIZE,
    IPN_VALIDATION_REGEX,
    NOT_SELECTED_OPTION,
    VIN_VALIDATION_REGEX
} from '../../constants/validationConstants';

export const required = (value, allValues) => {
    return (value || typeof value === 'number' || get(allValues, 'omitValidation', false) ? undefined : 'REQUIRED');
};

export const validEmails = value => {
    let error = undefined;
    if (value) {
        const emails = value.split(',');
        emails.forEach(email => {
            if (email) {
                const result = EMAIL_VALIDATION_REGEX.test(email) ? undefined : 'INVALID_EMAIL'
                if (result) {
                    error = result;
                }
            }
        })
    }
    return error;
};

export const validEmailArray = array => {
    if (Array.isArray(array) && array.length > 0) {
        array.forEach(item => {
                if (item.value && item.value.length > 0) {
                    return EMAIL_VALIDATION_REGEX.test(item.value) ? undefined : 'INVALID_EMAIL';
                }
            })
    }

    return undefined;
};

export const selectRequired = value =>
    (!value || value === NOT_SELECTED_OPTION ? 'REQUIRED' : undefined);

export const positiveNumber = value => (value !== null && ((value && isNaN(Number(value))) || value < 1) ? 'POSITIVE_NUMBER' : undefined);

export const minLength = min =>
    value =>
        value && value.length < min ? `Must be ${min} characters or more` : undefined;

export const validIPN = value =>
    (value && typeof value === 'string' && IPN_VALIDATION_REGEX.test(value)) ? undefined : 'INVALID_IPN';

export const validDate = value =>
    (value && !DATE_VALIDATION_REGEX.test(value)) ? 'INVALID_DATE' : undefined;

export const validDigitString = value =>
    (value && !DIGIT_STRING_VALIDATION_REGEX.test(value)) ? 'DIGITS_ONLY' : undefined;

export const validVin = value =>
    (value && !VIN_VALIDATION_REGEX.test(value)) ? 'INVALID_VIN' : undefined;

export const validInput = (value = '') => ((!COMMON_INPUT_VALIDATION_REGEX.test(value)) && value.length !== 0) ? 'INVALID_INPUT' : undefined;

export const validTicketFiles = fileList => {
    if (fileList) {
        if (fileList.length > 20)
            return 'MAXIMUM_FILES';
        if (fileList.length !== 0) {
            for (let i = 0; i < fileList.length; i++) {
                if (fileList[i].size > FILE_MAX_SIZE) {
                    return 'MAXIMUM_FILE_SIZE';
                }
            }
        }
    }
};

export const validQuestionFiles = file => {
    if (file) {
        if (file.size > FILE_MAX_SIZE) {
            return 'MAXIMUM_FILE_SIZE';
        }
    }
};
